/* istanbul ignore file */
/**
 * Tag component theme configuration.
 */

export const tagComponentConfig = {
  tag: {
    root: {
      fontSize: '10px',
      fontWeight: '400',
      padding: '0px 8px',
      gap: '4px',
      borderRadius: '{border.radius.xl}',
      roundedBorderRadius: '{border.radius.xl}',
    },
    icon: {
      size: '12px',
    },
    colorScheme: {
      light: {
        primary: {
          background: '{surface.0}',
          color: '{surface.800}',
        },
        secondary: {
          background: '{surface.200}',
          color: '{surface.700}',
        },
        success: {
          background: '{green.600}',
          color: '{surface.0}',
        },
        info: {
          background: '{sky.600}',
          color: '{surface.0}',
        },
        warn: {
          background: '{orange.600}',
          color: '{surface.0}',
        },
        danger: {
          background: '{red.600}',
          color: '{surface.0}',
        },
        contrast: {
          background: '{surface.950}',
          color: '{surface.0}',
        },
      },
    },
  },
};
